import React, { useState, Fragment } from 'react'
import Button from 'components/Button'
import { Modal } from 'components/Modal'
import { Form } from 'informed'
import { GroupedCheckboxes } from 'components/forms'
import { ReactComponent as FilterIco } from '../ColumnFilter.svg'
import { useTranslation } from 'react-i18next'

const withColFilter = WrappedComponent => ({ columns, ...rest }) => {
	const [t] = useTranslation()
	const [showtableColumns, setShowtableColumns] = useState(columns.map(col => ({
		show: col.show === false ? false : true,
		Header: col.Header,
		// identifier is needed to indentify hidden columns among 'tableColumns' in GroupedCheckboxes
		identifier: col.accessor
	})))
	const [showFilter, setShowFilter] = useState(false)
	// It's possible to not show some cols in cols filter form (e.g. 'id' column) by providing {hidden: true, accessor: 'string'}
	const hiddenItems = columns.filter(col => col.hidden).map(({ accessor, ...restCol }) => ({ ...restCol, identifier: accessor }))

	const ColFilterBtn = (
		<div key='colFilterBtn' style={{ cursor: 'pointer' }} onClick={() => setShowFilter(true)}>
			<FilterIco />
		</div>
	)

	const noDisplayedCols = !showtableColumns.some(col => col.show)
	let tableColumns = noDisplayedCols ? [{ Header: t('common.strings.table_no_columns') }] : columns.map((col, i) => ({
		...col,
		show: showtableColumns[i].show
	}))

	return(
		<Fragment>
			<WrappedComponent {...rest} columns={tableColumns} ColFilterBtn={ColFilterBtn}/>
			{showFilter &&
				<Modal width={910} label={t('common.strings.table_column_filter')} unmount={() => setShowFilter(false)}>
					<Form
						onSubmit={({ cols }) => {
							setShowtableColumns(cols)
							setShowFilter(false)
						}}
						initialValues={{ cols: showtableColumns }}
						render={({ formState, formApi }) => (
							<Fragment>
								<GroupedCheckboxes
									field='cols'
									cols={Math.ceil(columns.length / 5)}
									boolField='show'
									labelField='Header'
									listChecked
									hiddenItems={hiddenItems}
								/>
								<Button type='submit' status='primary' text={t('common.buttons.apply')}/>
							</Fragment>
						)}
					/>
				</Modal>
			}
		</Fragment>
	)
}

export default withColFilter

